angular.module('dnecom').controller('DoubleItProcessController', ["$scope", "$http", "$timeout", "notifications", "Upload", "ErrorBag", function($scope, $http, $timeout, notifications, Upload, ErrorBag) {
    $scope.upsell = TemplateData.value('upsell');
    $scope.store = TemplateData.value('store');
    $scope.products = TemplateData.value('products');
    $scope.firstOptionSelectorEnabled = false;
    $scope.data = {};
    $scope.errors = {};
    $scope.serverErrors = {};

    $scope.urlUploadBtnText = 'Upload from url';
    $scope.urlUploading = false;

    $scope.visibleProductSelector = {
        owning: false,
        linked: false
    };
    $scope.upsellTriggerProduct = null;
    $scope.upsellProduct = null;
    $scope.downsellEnabled = false;

    $scope.rules = {
        'value': {
            type: 'value',
            label: 'Value',
            options: {
                'single': {
                    type: 'single',
                    label: 'Single Condition',
                    options: [
                        {
                            type: 'above',
                            label: 'above'
                        },
                        {
                            type: 'below',
                            label: 'below'
                        },
                        {
                            type: 'equal',
                            label: 'equal'
                        }
                    ]
                },
                'range': {
                    type: 'range',
                    label: 'Range Condition'
                }
            }
        },
        'items-purchased': {
            type: 'items-purchased',
            label: 'Items purchased',
            options: {
                'single': {
                    type: 'single',
                    label: 'Single Condition',
                    options: [
                        {
                            type: 'above',
                            label: 'above'
                        },
                        {
                            type: 'below',
                            label: 'below'
                        },
                        {
                            type: 'equal',
                            label: 'equal'
                        }
                    ]
                },
                'range': {
                    type: 'range',
                    label: 'Range Condition'
                }
            }
        }
    };

    $scope.fonts = [
        'Arial',
        'Lato',
        'Helvetica',
        'Open Sans',
        'Montserrat',
        'Roboto',
        'Source Sans Pro',
        'Tahoma',
        'Verdana'
    ];

    $scope.init = function() {
        if (!$scope.upsell.type) {
            $scope.upsell.type = 'doubleit';
        }

        if (!$scope.upsell.fields) {
            $scope.upsell.fields = {};
        }

        if (!$scope.upsell.fields.buttonType) {
            $scope.upsell.fields.buttonType = 'standard';
        }

        if (!$scope.upsell.rules) {
            $scope.upsell.rules = [];
        }
    };

    $scope.showFirstOptionSelector = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        $scope.firstOptionSelectorEnabled = true;
    };

    $scope.hideOptionsSelector = function () {
        var result = $scope.firstOptionSelectorEnabled;
        $scope.firstOptionSelectorEnabled = false;

        //1clickit
        $scope.visibleProductSelector.owning = false;
        $scope.visibleProductSelector.linked = false;

        return result;
    };

    $scope.setFirstOption = function (type, firstOption, $event) {
        $event.preventDefault();

        $scope.upsell.rules.push({type: type, firstOption: firstOption});
        $scope.firstOptionSelectorEnabled = false;
    };

    $scope.removeRule = function (index, $event) {
        $event.preventDefault();

        $scope.upsell.rules.splice(index, 1);
    };

    $scope.moveRule = function(index, direction, $event) {
        $event.preventDefault();

        var temp;
        if (direction == 'up') {
            temp = $scope.upsell.rules[index - 1];
            $scope.upsell.rules[index - 1] = $scope.upsell.rules[index];
        } else {
            temp = $scope.upsell.rules[index + 1];
            $scope.upsell.rules[index + 1] = $scope.upsell.rules[index];
        }
        $scope.upsell.rules[index] = temp;
    };

    $scope.getMinMaxForRule = function(rule) {
        if (rule.hasOwnProperty('from')) {
            return rule.hasOwnProperty('from');
        }

        return 0;
    };

    $scope.save = function(form) {
        form.$setTouched();

        if (form.$invalid) {
            return;
        }

        $scope.errors = {};
        $scope.serverErrors = {};

        $http.post(
            Routing.generate('upsell_update', {store: $scope.store.id}),
            $scope.upsell
        ).then(function(response) {
            if (response.data.success) {
                notifications.success('Upsell updated successfully.');
                $scope.upsell = response.data.upsell;
            } else {
                notifications.danger(response.data.message || 'Failed to save upsell.');
            }
        }, function(response) {
            if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                for (var key in response.data.errors) {
                    var error = [];
                    for (var ikey in response.data.errors[key]) {
                        error.push(response.data.errors[key][ikey]);
                    }
                    $scope.errors[key] = error.join('; ');
                }

                $scope.serverErrors = ErrorBag.from(response.data.errors);
                notifications.danger('Form contains invalid data.');
            } else {
                notifications.danger('Request error.');
            }
        });
    };

    var beforeImageUpload = function() {
        $scope.urlUploadBtnText = 'Uploading...';
        $scope.urlUploading = true;
    };

    var afterImageUpload = function() {
        $scope.urlUploadBtnText = 'Upload from url';
        $scope.urlUploading = false;
    };

    $scope.upload = function (file) {
        beforeImageUpload();

        Upload.upload({
            url: Routing.generate('upload_file', {store: $scope.store.id}),
            data: {
                file: file
            }
        })
        .then(function (response) {
            if (response.data.success) {
                $scope.upsell.buttonMedia = response.data.media;
                $scope.upsell.fields.buttonMediaId = $scope.upsell.buttonMedia.id;
            } else {
                notifications.danger(response.data.message);
            }

            afterImageUpload();
        }, function () {
            notifications.danger('There was a problem with image uploading.');
            afterImageUpload();
        });
    };

    $scope.uploadFromUrl = function (url) {
        if (!url || !url.length) {
            return;
        }

        beforeImageUpload();

        $http.post(Routing.generate('upload_file', {store: $scope.store.id}), {
            image: url
        })
        .then(function (response) {
            if (response.data.success) {
                $scope.upsell.buttonMedia = response.data.media;
                $scope.upsell.fields.buttonMediaId = $scope.upsell.buttonMedia.id;
            } else {
                notifications.danger(response.data.message);
            }

            afterImageUpload();
        }, function () {
            notifications.danger('There was a problem with image uploading.');
            afterImageUpload();
        });
    };

    $scope.deleteUpsell = function() {
        $http.delete(
            Routing.generate('upsell_delete', {
                store: $scope.store.id,
                upsell: $scope.upsell.id
            })
            ).then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message || 'Failed to delete upsell.');
                    return;
                }

                notifications.success('Upsell deleted successfully.');
                window.location = Routing.generate('upsell_post_purchase_list', {store: $scope.store.id});
            }, function() {
                notifications.danger('Invalid server response.');
            }
        );
    };

    $(window).click(function () {
        if ($scope.hideOptionsSelector()) {
            $scope.$digest();
        }
    });

   $scope.onOwningProductSelect = function (product) {
       $scope.upsell.owningProduct = product.id;
       $scope.upsellTriggerProduct = product;
       $scope.visibleProductSelector.owning = false;
   };

   $scope.onLinkedProductSelect = function (product) {
       $scope.upsell.linkedProduct = product.id;
       $scope.upsellProduct = product;
       $scope.visibleProductSelector.linked = false;

   };

   $scope.owningProductDeselect = function () {
       $scope.upsell.owningProduct = null;
       $scope.upsellTriggerProduct = null;
   };

   $scope.linkedProductDeselect = function () {
       $scope.upsell.linkedProduct = null;
       $scope.upsellProduct = null;
   }
}]);
